import { render, staticRenderFns } from "./frontidcard.vue?vue&type=template&id=4fdd09b2&scoped=true&"
import script from "./frontidcard.vue?vue&type=script&lang=js&"
export * from "./frontidcard.vue?vue&type=script&lang=js&"
import style0 from "./frontidcard.vue?vue&type=style&index=0&id=4fdd09b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd09b2",
  null
  
)

export default component.exports